/**
 * Injects the AppsFlyer Smart Script.
 * @see {@link https://sweetgreen.atlassian.net/wiki/spaces/TD/pages/7042072584/AppsFlyer+Smart+Script}
 */
export function injectAppsFlyerSmartScript() {
  if (document.querySelector(`script[id="${APPS_FLYER_SMART_SCRIPT_ID}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.id = APPS_FLYER_SMART_SCRIPT_ID;
  script.type = 'text/javascript';
  script.src = APPS_FLYER_SMART_SCRIPT_URL;
  script.defer = true;

  document.head.appendChild(script);
}

// ─── Constants ───────────────────────────────────────────────────────────────

const APPS_FLYER_SMART_SCRIPT_ID = 'apps-flyer-smart-script';
const APPS_FLYER_SMART_SCRIPT_URL = '/apps-flyer-smart-script.js';
